<template>
  <div class="content">
<!--    <div class="code-title">快码推广</div>-->
    <div class="h" style="margin-top: 5.33333vw"></div>
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="serve_name"
          name="客服经理称呼"
          label="客服经理称呼"
          placeholder="请输入客服经理称呼"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="serve_tel"
          type="tel"
          name="客服经理电话"
          label="客服经理电话"
          placeholder="请输入客服经理电话"
          :rules="[{ required: true, message: '' }]"
        />
      </van-cell-group>
      <div style="margin: 8vw 4vw;">
        <van-button round block type="info" native-type="submit" style="background: #FDD80D;border-color: #FDD80D;color: #282828;font-weight: bold;">去推广</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "registerCode",
  data(){
    return{
      serve_name: '',
      serve_tel:'',
      userInfo:'',
      is_show_poster:1 // 1显示海报 0 不显示
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    async getUser () {
      const res = await this.$Http.getInfo()
      if (res.code == 200){
        const info = res.data;
        this.userInfo = info;
        this.$store.commit('setUserInfo', info)
      } else {
        this.$router.push('/');
      }
    },
    onSubmit(){
      this.$router.push({path:'/polyCode',query: {serveName:this.serve_name,serveTel:this.serve_tel,userId:this.userInfo.id,posterShow:this.is_show_poster}})
    }
  }
}
</script>

<style lang="scss" scoped>
  .code-title{
    padding: 40px;text-align: center;font-size: 32px;
  }
  .van-cell{
    padding: 0.36667rem 0.42667rem;
  }
  ///deep/.van-cell-group--inset{
  //  margin: 0;
  //}
</style>
